import { useEffect, useState } from "react";
import { NetworkTest } from "naruto-run";
import "./networktest.css";
import success from "../assets/check.svg";
import errorImg from "../assets/error.svg";

const OpenTokNetworkTest = () => {
  const [counter, setCounter] = useState(100);
  const [data, setData] = useState({
    loading: true,
    error: false,
    results: null,
  });
  const [isResultSatisfactory, setIsResultSatisfactory] = useState(false);
  const [isPermissionDenied, setIsPermissionDenied] = useState(false);
  const [loadingText, setLoadingText] = useState(true);

  useEffect(() => {
    setData({ ...data, loading: true });
  }, []);

  useEffect(() => {
    counter < 95 && setTimeout(() => setCounter(counter + 1), 250);
  }, [counter]);

  const sendResultsToParent = result =>
    window.parent.postMessage(JSON.stringify(result), "*");

  const onNetworkTestComplete = (results, error) => {
    if (!error) {
      sendResultsToParent(results);
      checkResultValue(results);
      setCounter(100);
    } else {
      sendResultsToParent({ error: true });
    }
    setData({ ...data, results, error, loading: false });
    if (error?.error?.message?.includes("Permission denied") !== -1)
      setIsPermissionDenied(true);
  };

  const checkResultValue = results => {
    if (results.video.mos >= 3.1 && results.audio.mos >= 3.1)
      setIsResultSatisfactory(true);
  };

  const onStartup = () => {
    setTimeout(() => {
      setCounter(0);
      setLoadingText(false);
    }, 1000);
  };

  const { loading, error } = data;

  return (
    <div className="networktest-progress-container">
      <NetworkTest
        apiKey={process.env.REACT_APP_API_KEY}
        apiSecret={process.env.REACT_APP_API_SECRET}
        onSuccess={results => onNetworkTestComplete(results, null)}
        onFailure={error => onNetworkTestComplete(null, error)}
        onStart={onStartup}
      />
      {loadingText && (
        <p className="networktest-progress-text">
          Checking connections to our server
        </p>
      )}
      {!loading && error && !loadingText && (
        <>
          {isPermissionDenied ? (
            <p className="networktest-progress-error-helpertext">
              Please enable permissions for audio and video in your browser to
              run a speed test!
            </p>
          ) : (
            <p className="networktest-progress-error-helpertext">
              Something went wrong while running the test ! Please try again
            </p>
          )}
        </>
      )}
      {loading && !error && !loadingText && (
        <>
          <p className="no-time-plead-text">Please give us a moment</p>
          <p className="networktest-progress-text">
            We're running a test to check if a video session can take place
            seamlessly...
          </p>
          <progress
            className="networktest-progress-progressbar"
            max="100"
            value={counter}
          ></progress>
        </>
      )}
      {!loading && !error && !loadingText && (
        <>
          <p className="networktest-progress-result-maintext">
            Your audio-video quality is{" "}
            {isResultSatisfactory ? "satisfactory" : "not satisfactory"}
            <img
              src={isResultSatisfactory ? success : errorImg}
              alt="Result"
              className="networktest-progress-result-img"
            />
          </p>
          {isResultSatisfactory ? (
            <p className="networktest-progress-result-helpertext">
              You can access the session seamlessly. If you face any issues,
              call us at <a href="tel:02071171501">020 7117 1501</a>.
            </p>
          ) : (
            <p className="networktest-progress-result-helpertext danger">
              We recommend you to switch to a telephone session. You can do this
              by calling us at <a href="tel:02071171501">020 7117 1501</a>.
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default OpenTokNetworkTest;
